import { FormGroup } from '@angular/forms';

import { SubmissionConstants } from '../../models/constants/submissions-constants';
import {
  FormRule,
  FormRuleEffect,
  FormRuleFactory,
  RuleAction,
} from '../../../../shared/forms';
import { TokenClaimsService } from '../../../../shared/services';

export class WaterHeaterRules {
  constructor(
    private ruleFact: FormRuleFactory,
    private submissionsConst: SubmissionConstants,
    private tokenService: TokenClaimsService,
  ) {}

  getV3CustomRules(subValues: FormGroup): FormRule[] {
    const shouldOverrideWaterHeaterValue =
      this.tokenService.isEnergyCreditAdmin || this.tokenService.isSupport;

    const isAlternateConstruction = this.isAlternateConstructionSerial(
      subValues.get('homeSerialNumber')?.value,
    );
    const hasEBuiltDesignOption = [
      'originalEBuiltElectric',
      'electricEBuiltPlus',
      'originalEBuiltGas',
      'gasEBuiltPlus',
    ].includes(subValues.get('energyEfficiencyType')?.value);

    if (isAlternateConstruction) {
      return [
        this.ruleFact.createRule(`${true}`, [
          this.setWaterHeating(RuleAction.MAKE_ENABLED),
          this.setWaterHeating(RuleAction.CLEAR_ERROR_MESSAGE),
          this.setWaterHeating(RuleAction.SET_WARNING_MESSAGE, ''),
        ]),
      ];
    }

    if (shouldOverrideWaterHeaterValue && hasEBuiltDesignOption) {
      return [
        this.ruleFact.createRule(`${true}`, [
          this.setWaterHeating(
            RuleAction.SET_WARNING_MESSAGE,
            this.submissionsConst.waterHeatingEBuiltWarning,
          ),
          this.setWaterHeating(RuleAction.MAKE_ENABLED),
        ]),
      ];
    } else if (!shouldOverrideWaterHeaterValue && !hasEBuiltDesignOption) {
      return [
        this.ruleFact.createRule(`${true}`, [
          this.setWaterHeating(RuleAction.MAKE_DISABLED),
          this.setWaterHeating(RuleAction.SET_TOOLTIP, ''),
        ]),
      ];
    } else if (!shouldOverrideWaterHeaterValue && hasEBuiltDesignOption) {
      this.setFormError(subValues, 'waterHeatingInvalid');
      return [
        this.ruleFact.createRule(`${true}`, [
          this.setWaterHeating(RuleAction.MAKE_DISABLED),
          this.setWaterHeating(
            RuleAction.SET_ERROR_MESSAGE,
            this.submissionsConst.waterHeatingEBuiltWarning,
          ),
          this.setWaterHeating(RuleAction.MAKE_INVALID),
        ]),
      ];
    }
    return [];
  }

  private isAlternateConstructionSerial(serialNumber: string): boolean {
    return (serialNumber ?? '').includes('AC');
  }

  private setWaterHeating(action: RuleAction, value?: string): FormRuleEffect {
    return {
      action,
      affectingType: 'control',
      applyTo: 'waterHeating',
      value,
    };
  }

  private setFormError(form: FormGroup, key: string): void {
    const currentErrors = { ...(form.errors ?? {}) };
    form.setErrors({ ...currentErrors, [key]: true });
  }
}
